import { render } from "./Shipments.vue?vue&type=template&id=7a038e06"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"

import "./Shipments.vue?vue&type=style&index=0&id=7a038e06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__